// Scoped to the preview subtree; never written into the visitor's Vuex/storage.
export const STOREFRONT_PREVIEW_KEY = Symbol('storefront-preview')
